import { isProductionEnv } from '@ourbranch/env-helpers';
import { appConfig } from 'brand-config';

/**
 * Agency sweep accounts (#33155) are gated per-brand AND per-environment. The brand
 * config carries two booleans (`enabledInNonProd` / `enabledInProd`) so a mutual can
 * pilot the feature in dev/staging while it stays off in production. Currently on
 * (non-prod) for CFM, Oakwood, and Forreston; off everywhere else.
 */
export const resolveSweepAccountsEnabled = (flag, isProd) => {
  if (!flag) {
    return false;
  }
  return isProd ? Boolean(flag.enabledInProd) : Boolean(flag.enabledInNonProd);
};

export const isSweepAccountsEnabled = () =>
  resolveSweepAccountsEnabled(
    appConfig?.featureFlags?.sweepAccounts,
    isProductionEnv(import.meta.env?.VITE_STACKERY_ENVIRONMENT)
  );
